export default __webpack_public_path__ + "static/media/PCC.6ae07d14.png";